import React from 'react';
import CloseIcon from '@material-ui/icons/Close';
//
import {
  ModalTitleContainer,
  ModalTitle,
  ModalContent,
  ModalButtonContainer,
  ModalCloseButton,
} from 'components/modal-provider/modal';
import { modalCloseIcon } from 'constants/test-ids';

export default ({
  buttons,
  onClose,
  content,
  title,
}: {
  buttons: React.ReactNode;
  onClose: () => void;
  content: React.ReactNode;
  title: string;
}) => {
  return (
    <>
      <ModalTitleContainer>
        <ModalTitle>{title}</ModalTitle>
        <ModalCloseButton onClick={onClose} data-testid={modalCloseIcon}>
          <CloseIcon />
        </ModalCloseButton>
      </ModalTitleContainer>
      <ModalContent>{content}</ModalContent>
      <ModalButtonContainer>{buttons}</ModalButtonContainer>
    </>
  );
};
